// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const Specificator_Type = {
    Customer: 6750208,
    Supplier: 6750209,
    More: 6750210,
    None: 6750211,
    Ignore: 6750212,
};
